module.exports = __webpack_public_path__ + "img/about-honor1.06eca05.png";